import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { ModalService } from '../../../../../services/modal.service'
import { SharedServices } from '../../../../../services/shared.services'
import { ClientDetailServices } from '../../../../../services/ClientDetail.services'
import { FormBuilder, FormGroup } from '@angular/forms'
import * as $ from 'jquery'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker.js'
import * as moment from 'moment'

import { ClientTopServices } from '../../../../../services/ClientTop.services'
import { ActivatedRoute } from '@angular/router'
import { notification, openActionSheet } from 'onsenui'
import { MatrixServices } from '../../../../../services/image/matrix.services'
import Constants from '../../../../../commons/Constants'
import { MultipleImageHelper } from '@helpers/mutiple-image.helper'

window['jQuery'] = window['$'] = $

@Component({
    selector: 'app-modal-client-detail-top-registration',
    templateUrl: './modal-client-detail-registration.component.html',
    styleUrls: [
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        './modal-client-detail-registration.component.css',
    ],
})
export class ModalClientDetailRegistrationComponent implements OnInit, OnDestroy {
    en: any = {}
    showEN = true
    option_Registration: String = 'hidden'
    option_Registration_Face: String = ''
    option_Registration_Tooth: String = ''
    TabRegistrationClass: any
    docIcon: any
    valChange: any = 0
    countArrDataRegistration: number
    senMax: any = 100
    max: any = 0
    count: any = 0
    showPaste: Boolean = false
    ValueAssignOneDistance: any
    showDatepicker = 'hidden'
    arayListNote: any
    isCreate: Boolean = false
    isCut: Boolean = false
    isUpdateImageSet: Boolean = false
    planClass
    arrTabRegistration = Constants.TOP_MAIN_TABS
    showDate: String = 'Click to Select'
    isShow: Boolean = false
    timestampStart: number
    timestampLast: number
    loadingCheck: Boolean = false

    dateStart: any
    myGroup: FormGroup
    optionsStartDate: any = {
        format: 'YYYY.MM.DD ddd',
        showTodayButton: true,
        useCurrent: false,
        keepOpen: true,
        ignoreReadonly: false,
        debug: true,
    }

    resourceUrl = 'resource'
    idClient: string
    arrRegistrationShow: any[] = []
    arrRegistration: any[] = []
    statusImage: Boolean = false
    timeline: any
    index: any = 0
    height: any
    emitTabName: any = {}
    arrayListNote: any[] = []
    valChangeNodeText
    isChangeNodeText: Boolean
    indexBeforChange
    tabName: any
    arrStyle: any[] = []
    page: any = 'registration'
    countArrAllClientTop: any = 0
    faceImage
    contentNote
    showTextareaNote: any
    textareaNote: boolean = true
    clientInfoUrl
    cordinator
    listNoteActive: any[] = []
    hideFooter = false
    dsdActive = false
    smileActive = false
    dsdIndex = 0
    createDsd = false
    updateDsd = false
    discardDsd = false
    cutDsd = false
    pastedIndex = -1
    cutData = {}
    cutIndex = -1
    unsubSlider
    changeEmittedIndex: any

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private _clientDetailServices: ClientDetailServices,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices,
                private route: ActivatedRoute,
                public matrixServices: MatrixServices) {
    }


    ngOnInit() {
        this.showTextareaNote = 'hidden'
        this.matrixServices.arrRotate = [0, 0, 0, 0, 0, 0]
        this.myGroup = this.formBuider.group({
            startDate: [''],
        })
        this.option_Registration = 'active'
        this.getTabRegistrationClass()
        this.option_Registration_Face = 'hidden'
        this.option_Registration_Tooth = 'hidden'
        this.valChange = 0
        const emitInit: any = {}
        emitInit['init'] = ''
        this.clientTopServices.emitChangeInit(emitInit)
        this.clientTopServices.changecheckDataAfterConfirm(false)
        this.route.parent.paramMap.subscribe(params => {
            if (params.get('id') != '') {
                this.idClient = params.get('id') ? params.get('id') : ''
                this.getRegistration()
                this.getArrNoteList()
                this.getImageFacImage()
                this.getIndex()
            }
        })
        this.getArrCopy()
        this.height = ($(window).height() / 6) - $(window).height()
        this.clientTopServices.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ModalListImageTopComponent-keyTimeRecondMove') {
                        const timeRecornd = success[1]
                        const indexCurreny = success[2]
                        this.checkConfirmAlertMoveFormModalList(timeRecornd, indexCurreny)
                    }
                }
            },
        )

        this.clientTopServices.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ModalListNoteTopComponent-ListNoteSelect') {
                        if (success[1]) {
                            this.arayListNote = success[1]
                            this.isUpdateImageSet = true
                        }
                    }
                }
            },
        )
        this.getTabName()
        this.changeValueEx1SliderRegister()
        // this.getResetValueFromModalListImage();
        this.SaveListNodeWhenChangeTab()
    }

    getIndex() {
        this.changeEmittedIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            if (infoIndex != null && infoIndex['index'] != undefined) {
                this.index = infoIndex['index']
                this.ValueAssignOneDistance = this.senMax / this.max
                this.valChange = this.ValueAssignOneDistance * this.index
            }
        })
    }

    ngOnDestroy() {
        this.clientTopServices.emitChangeSlider(null)
        this.isCreate = false
        this.clearDsdStorage()
        if(this.unsubSlider)
            this.unsubSlider.unsubscribe()
    }

    clearDsdStorage() {
        window['canvasVideoCopy'] = ''
        window['canvasChange'] = false
        window['canvasSave'] = ''
        window['canvasImgDemoSave'] = ''
        window['canvasImgBeforeSave'] = ''
        window['canvasImgBaseSave'] = ''
        window['canvasVideoSave'] = ''
    }

    SaveListNodeWhenChangeTab() {
        this.clientTopServices.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ClientDetailComponent-keyListnodeSave-ModalClientDetailRegistrationComponent') {
                        if (this.isUpdateImageSet) {
                            this.saveUpdateImageSet()
                        }
                    }
                }
            },
        )
    };

    // getResetValueFromModalListImage() {
    //   this.clientTopServices.changeEmitted$.subscribe(
    //     success => {
    //       if (success) {
    //         if (success[0] === 'ModalListImageTopComponent-arrayClientVisitUpdateRegitration-ModalClientDetailRegistrationComponent') {
    //           if (success[1] === 0) {
    //             this.countArrAllClientTop = 0;
    //             this.arrRegistration = [];
    //             this.isShow = false;
    //             this.showDate = 'Click to Select';
    //             this.dateStart = undefined;
    //           }
    //         }
    //       }
    //     }
    //   );
    // };

    showLink() {
        const clientInfoUrl = this.clientInfoUrl
        const arrayClientInfoUrl = []
        for (let j = 0; j < clientInfoUrl.length; j++) {
            arrayClientInfoUrl.push(
                {
                    label: clientInfoUrl[j]['title'],
                },
            )
        }
        const labelCancel = { label: 'Cancel', icon: 'md-close' }
        arrayClientInfoUrl.push(labelCancel)
        openActionSheet({
            title: 'Open URL',
            cancelable: true,
            buttons: arrayClientInfoUrl,
            callback: i => {
                for (let k = 0; k < clientInfoUrl.length; k++) {
                    if (i === k) {
                        window.open(clientInfoUrl[k]['url'])
                    }
                }
            },
        })
    }

    showTextNote(data: boolean) {
        if (data === true) {
            this.showTextareaNote = 'active'
        } else {
            this.showTextareaNote = 'hidden'
        }
        this.textareaNote = !data
    }

    writeNote() {
        this.isChangeNodeText = true
        const ArrayValueNote = ['ModalClientDetailRegistrationComponent-arrayNoteList', this.contentNote, this.valChangeNodeText]
        this.clientTopServices.emitChangeNote(ArrayValueNote)
    }

    confirmNodeText() {
        this.clientTopServices.changecheckDataAfterConfirm(true)
    }

    getTabRegistrationClass() {
        const tabName: any = this.clientTopServices.getTabName()
        switch (tabName) {
            case 'face-1':
            case 'face-2':
            case 'face-3':
            case 'face-4':
            case 'face-5':
            case 'face-6':
                this.TabRegistrationClass = 'option_0'
                this.tabName = 'face-all'
                this.emitTabName['tabName'] = 'face-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'face-all':
                this.TabRegistrationClass = 'option_0'
                this.tabName = 'face-all'
                break
            case 'tooth-right':
            case 'tooth-left':
            case 'tooth-front':
            case 'tooth-upper':
            case 'tooth-overjet':
            case 'tooth-lower':
                this.TabRegistrationClass = 'option_1'
                this.tabName = 'tooth-all'
                this.emitTabName['tabName'] = 'tooth-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'tooth-all':
                this.TabRegistrationClass = 'option_1'
                this.tabName = 'tooth-all'
                break
            case 'aligner-right':
            case 'aligner-left':
            case 'aligner-front':
            case 'aligner-upper':
            case 'aligner-overjet':
            case 'aligner-lower':
                this.TabRegistrationClass = 'option_2'
                this.tabName = 'aligner-all'
                this.emitTabName['tabName'] = 'aligner-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'aligner-all':
                this.TabRegistrationClass = 'option_2'
                this.tabName = 'aligner-all'
                break
            case 'xp-1':
            case 'xp-2':
            case 'xp-3':
            case 'xp-4':
            case 'xp-5':
            case 'xp-6':
                this.TabRegistrationClass = 'option_3'
                this.tabName = 'xp-all'
                this.emitTabName['tabName'] = 'xp-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'xp-all':
                this.TabRegistrationClass = 'option_3'
                this.tabName = 'xp-all'
                break
            case 'other-1':
            case 'other-2':
            case 'other-3':
            case 'other-4':
            case 'other-5':
            case 'other-6':
                this.TabRegistrationClass = 'option_4'
                this.tabName = 'other-all'
                this.emitTabName['tabName'] = 'other-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'other-all':
                this.TabRegistrationClass = 'option_4'
                this.tabName = 'other-all'
                break
            case 'movie-1':
            case 'movie-2':
            case 'movie-3':
            case 'movie-4':
            case 'movie-5':
            case 'movie-6':
                this.TabRegistrationClass = 'option_5'
                this.tabName = 'movie-all'
                this.emitTabName['tabName'] = 'movie-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'movie-all':
                this.TabRegistrationClass = 'option_5'
                this.tabName = 'movie-all'
                break
            case 'dsd':
                this.TabRegistrationClass = 'option_7'
                this.tabName = 'dsd'
                this.emitTabName['tabName'] = 'dsd'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'smile':
                this.TabRegistrationClass = 'option_6'
                this.tabName = 'smile'
                this.emitTabName['tabName'] = 'smile'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'dental-all':
                this.TabRegistrationClass = 'option_8'
                this.tabName = 'dental-all'
                break
            default:
                this.TabRegistrationClass = 'option_1'
                this.tabName = 'tooth-all'
                this.emitTabName['tabName'] = 'tooth-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
        }
    }

    getImageFacImage() {
        this.clientTopServices.changeEmitGetFaceImage$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ClientDetailComponent-clientFaceImage') {
                        if (success[1]) {
                            this.faceImage = success[1]
                        }
                    }
                }
            },
        )
    };

    getTabName() {
        this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
            if (infoTabName != null && infoTabName['tabName'] != undefined) {
                this.tabName = infoTabName['tabName']
            } else {
                this.tabName = 'tooth-all'
            }
        })
    }


    toggleTabItem(id, option, event, cordinator) {
        if (this.listNoteActive.length > 0) {
            if (this.listNoteActive.indexOf(id) !== -1) {
                this.listNoteActive.splice(this.listNoteActive.indexOf(id), 1)
            } else {
                this.listNoteActive.push(id)
            }
        } else {
            this.listNoteActive.push(id)
        }
    };

    checkConfirmAlertMoveFormModalList(timeRecornd, indexCurreny) {
        const assignCurenly = this.getvalChangeFromIndex(indexCurreny)
        const assign = this.getAssignFromaTimesTamplast(timeRecornd)
        this.checkAlertConFirmWhenNextDay(assignCurenly, assign)
    }

    getArrNoteList() {
        this.clientTopServices.changeEmittedNoteList$.subscribe(noteList => {
            if (noteList != null && noteList['arrayNoteList'] != undefined) {
                this.arrayListNote = noteList['arrayNoteList']
            }
        })
    }

    // convert image base64 to image file
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
    }

    saveAfterChangeData() {
        this.changeLanguage()
        if (window['canvasChange']) {
            this.clientTopServices.checkChangeData = true
        }
        if (this.clientTopServices.checkChangeData === true) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        if (this.isUpdateImageSet) {
                            this.saveUpdateImageSet()
                        }
                        if (this.isChangeNodeText) {
                            this.saveUpdateNodeText()
                        }
                        // this.onSave();
                        this.confirmSaved()
                        window['canvasChange'] = false
                    }
                },
            })
        }
    }

    confirmSaved() {
        if (this.tabName == 'dsd' || this.tabName == 'smile') {
            const index = this.clientTopServices.getIndex()
            this.uploadDSD(index, -1)
        } else {
            this.onSave()
        }
    }

    uploadDSD(index, newValue) {
        document.getElementById('save-canvas-btn').click()
        const canvas = window['canvasSave']
        if (canvas && canvas != 'undefined') {
            this.clientTopServices.canvasModalLoading$.next({ show: true, status: 'save' })
            let sendImgs = {}
            let hasImg = window['canvasImgBaseSave'] && window['canvasImgBaseSave'] != 'undefined'
            if (!this.cutDsd && this.tabName == 'dsd' && hasImg) {
                const imgBaseFile = this.dataURLtoFile(window['canvasImgBaseSave'], 'canvasImgBase')
                const imgBeforeFile = this.dataURLtoFile(window['canvasImgBeforeSave'], 'canvasImgBefore')
                const imgDemoFile = this.dataURLtoFile(window['canvasImgDemoSave'], 'canvasImgDemo')
                sendImgs = {
                    imgBase: imgBaseFile,
                    imgBefore: imgBeforeFile,
                    imgDemo: imgDemoFile,
                }
            } else if (!this.cutDsd && this.tabName == 'dsd' && !hasImg) {
                const imgDemoFile = this.dataURLtoFile(window['canvasImgDemoSave'], 'canvasImgDemo')
                sendImgs = {
                    imgDemo: imgDemoFile,
                }
            } else if (!this.cutDsd && this.tabName == 'smile' && hasImg) {
                const imgBaseFile = this.dataURLtoFile(window['canvasImgBaseSave'], 'canvasImgBase')
                const imgDemoFile = this.dataURLtoFile(window['canvasImgDemoSave'], 'canvasImgDemo')
                sendImgs = {
                    imgBase: imgBaseFile,
                    imgDemo: imgDemoFile,
                }
            }

            this.authData.authToken().then(tokenReNew => {
                this.restApi.postCanvasImgs('image/create/', sendImgs, tokenReNew, this.tabName).subscribe(
                    data => {
                        if (this.tabName == 'dsd') {
                            if (!this.cutDsd) {
                                if (hasImg) {
                                    this.arrRegistration[index]['dsd'] = {
                                        canvas: canvas,
                                        canvasImgBase: data[0].hash,
                                        canvasImgDemo: data[1].hash,
                                        canvasImgBefore: data[2].hash,
                                    }
                                } else {
                                    this.arrRegistration[index]['dsd'] = {
                                        canvas: canvas,
                                        canvasImgBase: '',
                                        canvasImgDemo: data[0].hash,
                                        canvasImgBefore: '',
                                    }
                                }
                                let canvasVideo = window['canvasVideoSave']
                                if (canvasVideo && canvasVideo != 'undefined') {
                                    const part1 = canvasVideo.split('?AWSAccessKeyId')[0]
                                    const part1Arr = part1.split('/')
                                    this.arrRegistration[index]['dsd'].canvasVideo = part1Arr[part1Arr.length - 1]
                                }
                            } else {
                                this.arrRegistration[index]['dsd'] = null
                                this.cutDsd = false
                            }

                        } else {
                            if (!this.cutDsd && data) {
                                this.arrRegistration[index]['smile'] = {
                                    canvas: canvas,
                                    canvasImgBase: data[0].hash,
                                    canvasImgDemo: data[1].hash,
                                }
                            } else {
                                this.arrRegistration[index]['smile'] = null
                                this.cutDsd = false
                            }
                        }


                        window['canvasSave'] = ''
                        window['canvasImgBaseSave'] = ''
                        window['canvasImgBeforeSave'] = ''
                        window['canvasImgDemoSave'] = ''
                        window['canvasVideoSave'] = ''

                        this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                        this.clientTopServices.changecheckDataAfterConfirm(false)
                        if (newValue != -1) {
                            const assign = this.getAssignCalculateChange(newValue)
                            this.valChange = assign
                            this.getDateWhenChangeSliderRegister(assign)
                        }
                        window['canvasChange'] = false
                        this.dsdIndex = index
                        this.onSave()

                        if (this.updateDsd) {
                            this.updateDsd = false
                        }
                        this.cutDsd = false
                    }, error => {
                        this.clientTopServices.canvasModalLoading$.next({ show: false, status: 'save' })
                    },
                )
            })
        }

        if ((!canvas || canvas == 'undefined') && newValue != -1) {
            this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
            const assign = this.getAssignCalculateChange(newValue)
            this.valChange = assign
            this.getDateWhenChangeSliderRegister(assign)
        }
    }


    getFrontSmileToAvatar(arrImageClientTop) {
        const arrImageClientTopFrontSmile = arrImageClientTop
        for (let i = arrImageClientTopFrontSmile.length - 1; i >= 0; i--) {
            if (arrImageClientTopFrontSmile[i]['face-1'] != undefined && arrImageClientTopFrontSmile[i]['face-1'].length > 0 && arrImageClientTopFrontSmile[i]['face-1'][0]['id'] !== '') {
                return arrImageClientTopFrontSmile[i]['face-1'][0]
            } else if (i == 0) {
                return arrImageClientTopFrontSmile[i]['face-1'][0]
            }
        }
    }

    callApiUpdateFaceImage(imageFace) {
        const clientId = {}
        const result = this.idClient
        clientId[result] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [
                {
                    collection: 'client',
                    id: this.idClient,
                    type: 'update',
                    value: {
                        faceImage: imageFace,
                    },
                },
            ],
            status: {
                client: {
                    map: clientId,
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            let currentClientId = this.route.parent.snapshot.paramMap.get('id');
            if(currentClientId == this.idClient) {
                this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                    this.faceImage = success['response']['client']['map'][result]['faceImage']
                    const imageFaceClient = ['ModalClientDetailRegistrationComponent-imageFaceClient', success['response']['client']['map'][result]['faceImage']]
                    this._sharedService.emitChangeImageFace(imageFaceClient)
                })
            }
        })
    }


    onSave() {
        const bodyUpdate: any = {}
        let resourceData: any = {}
        const arrSaveClientTop: any[] = this.clientTopServices.getAllArrClientTop()
        let index = 0
        if (this.tabName == 'dsd' || this.tabName == 'smile') {
            index = this.dsdIndex
        } else {
            index = this.clientTopServices.getIndex()
        }
        let jsonNow: any
        let id: any = ''
        const result = '{"clientId":"' + this.idClient + '"}'
        const clientVisit: any = {}
        clientVisit[result] = true
        const status: any = {
            clientVisit: {
                paths: clientVisit,
            },
        }
        if (arrSaveClientTop[index]) {
            jsonNow = arrSaveClientTop[index]
            if (jsonNow['_id']) {
                id = jsonNow['_id']
            }
            bodyUpdate['clientId'] = this.idClient
            bodyUpdate['face-1'] = jsonNow['face-1']
            bodyUpdate['face-2'] = jsonNow['face-2']
            bodyUpdate['face-3'] = jsonNow['face-3']
            bodyUpdate['face-4'] = jsonNow['face-4']
            bodyUpdate['face-5'] = jsonNow['face-5']
            bodyUpdate['face-6'] = jsonNow['face-6']
            bodyUpdate['face-all'] = jsonNow['face-all']

            bodyUpdate['tooth-all'] = jsonNow['tooth-all']
            bodyUpdate['tooth-right'] = jsonNow['tooth-right']
            bodyUpdate['tooth-front'] = jsonNow['tooth-front']
            bodyUpdate['tooth-left'] = jsonNow['tooth-left']
            bodyUpdate['tooth-lower'] = jsonNow['tooth-lower']
            bodyUpdate['tooth-overjet'] = jsonNow['tooth-overjet']
            bodyUpdate['tooth-upper'] = jsonNow['tooth-upper']

            bodyUpdate['aligner-all'] = jsonNow['aligner-all']
            bodyUpdate['aligner-right'] = jsonNow['aligner-right']
            bodyUpdate['aligner-front'] = jsonNow['aligner-front']
            bodyUpdate['aligner-left'] = jsonNow['aligner-left']
            bodyUpdate['aligner-lower'] = jsonNow['aligner-lower']
            bodyUpdate['aligner-overjet'] = jsonNow['aligner-overjet']
            bodyUpdate['aligner-upper'] = jsonNow['aligner-upper']

            bodyUpdate['xp-1'] = jsonNow['xp-1']
            bodyUpdate['xp-2'] = jsonNow['xp-2']
            bodyUpdate['xp-3'] = jsonNow['xp-3']
            bodyUpdate['xp-4'] = jsonNow['xp-4']
            bodyUpdate['xp-5'] = jsonNow['xp-5']
            bodyUpdate['xp-6'] = jsonNow['xp-6']
            bodyUpdate['xp-all'] = jsonNow['xp-all']

            bodyUpdate['other-1'] = jsonNow['other-1']
            bodyUpdate['other-2'] = jsonNow['other-2']
            bodyUpdate['other-3'] = jsonNow['other-3']
            bodyUpdate['other-4'] = jsonNow['other-4']
            bodyUpdate['other-5'] = jsonNow['other-5']
            bodyUpdate['other-6'] = jsonNow['other-6']
            bodyUpdate['other-all'] = jsonNow['other-all']

            bodyUpdate['movie-1'] = jsonNow['movie-1']
            bodyUpdate['movie-2'] = jsonNow['movie-2']
            bodyUpdate['movie-3'] = jsonNow['movie-3']
            bodyUpdate['movie-4'] = jsonNow['movie-4']
            bodyUpdate['movie-5'] = jsonNow['movie-5']
            bodyUpdate['movie-6'] = jsonNow['movie-6']
            bodyUpdate['movie-all'] = jsonNow['movie-all']
            bodyUpdate['dsd'] = jsonNow['dsd'] ? jsonNow['dsd'] : null
            bodyUpdate['smile'] = jsonNow['smile'] ? jsonNow['smile'] : null

            bodyUpdate['note'] = this.contentNote

            bodyUpdate['dental-1'] = jsonNow['dental-1']
            bodyUpdate['dental-2'] = jsonNow['dental-2']
            bodyUpdate['dental-3'] = jsonNow['dental-3']
            bodyUpdate['dental-4'] = jsonNow['dental-4']
            bodyUpdate['dental-5'] = jsonNow['dental-5']
            bodyUpdate['dental-6'] = jsonNow['dental-6']
            bodyUpdate['dental-7'] = jsonNow['dental-7']
            bodyUpdate['dental-8'] = jsonNow['dental-8']
            bodyUpdate['dental-9'] = jsonNow['dental-9']
            bodyUpdate['dental-10'] = jsonNow['dental-10']
            bodyUpdate['dental-11'] = jsonNow['dental-11']
            bodyUpdate['dental-12'] = jsonNow['dental-12']
            bodyUpdate['dental-all'] = jsonNow['dental-all']
            if (id != '') {
                resourceData = this.restApi.makeResourceObject({
                    actions: [
                        {
                            type: 'update',
                            collection: 'clientVisit',
                            id: id,
                            value: bodyUpdate,
                        },
                    ],
                    status: status,
                })
            } else {
                resourceData = this.restApi.makeResourceObject({
                    actions: [
                        {
                            type: 'create',
                            collection: 'clientVisit',
                            value: bodyUpdate,
                        },
                    ],
                    status: status,
                })
            }
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                    this.arrRegistration = success['response']['clientVisit']['paths']['' + result]
                    this.countArrDataRegistration = success['response']['clientVisit']['paths']['' + result].length
                    this.max = this.countArrDataRegistration - 1
                    const tmp: number = this.senMax / this.max
                    // const assign = tmp;
                    if (this.max > 0) {
                        this.ValueAssignOneDistance = this.senMax / this.max
                        this.valChange = this.ValueAssignOneDistance * this.index
                    } else {
                        this.valChange = 0
                    }
                    if (this.countArrDataRegistration > 0) {
                        this.arrRegistration = this.arrRegistration.sort((function(obj1, obj2) {
                            return obj1.dateString.localeCompare(obj2.dateString);
                        }))
                        const imageFrontSmile = this.getFrontSmileToAvatar(this.arrRegistration)
                        if (imageFrontSmile !== undefined) {
                            if (typeof this.faceImage === 'undefined') {
                                this.callApiUpdateFaceImage(imageFrontSmile)
                            } else if (this.faceImage !== '') {
                                if (this.faceImage['id'] !== imageFrontSmile['id']) {
                                    this.callApiUpdateFaceImage(imageFrontSmile)
                                } else if (imageFrontSmile['matrix'] != undefined && this.faceImage['matrix'] !== imageFrontSmile['matrix'].toString()) {
                                    this.callApiUpdateFaceImage(imageFrontSmile)
                                }
                            }
                        }
                        this.arrRegistrationShow = this.arrRegistration[this.index]
                        const emitArrAll: any = {}
                        emitArrAll['registration'] = this.arrRegistration
                        emitArrAll['checkChange'] = false
                        this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                        if (this.arrRegistration[this.index] != undefined) {
                            this.timeline = this.arrRegistration[this.index]['dateStringToInit'] ? this.arrRegistration[this.index]['dateStringToInit'] : ''
                        }
                        if (this.timeline !== '') {
                            const showdateAdd = moment(this.timeline).format('YYYY.MM.DD ddd')
                            this.showDate = this.dateStart = showdateAdd
                        }
                    } else {
                        const arrEmit = this.createArrAllClientTop()
                        const emitArrAll: any = {}
                        emitArrAll['registration'] = arrEmit
                        emitArrAll['checkChange'] = false
                        this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                    }
                    if (this.createDsd) {
                        this.onCreate(this.timestampLast)
                    } else {
                        this.clientTopServices.canvasModalLoading$.next({ show: false, status: 'save' })
                    }
                    this.pastedIndex = -1
                    this.clientTopServices.resetListImageTemporary()
                })
            })
        }
    }


    getRegistration() {
        this.clientTopServices.changeEmittedNoteList$.subscribe(arrayNoteList => {
            if (arrayNoteList != null && arrayNoteList['arrayNoteList'] !== undefined) {
                this.arayListNote = arrayNoteList['arrayNoteList']
            }
        })
        this.clientTopServices.changeEmitChangeInfoUrlChange$.subscribe(success => {
            if (success) {
                if (success[0] === 'ClientDetailComponent-clientInfoUrl') {
                    this.clientInfoUrl = success[1]
                }
            }
        })
        this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            if (arrAll != null && arrAll['registration'] !== undefined && arrAll['registration'].length > 0) {
                if (arrAll && arrAll['forceDelete']) {
                    window['canvasVideoCopy'] = ''
                    window['canvasSave'] = ''
                    window['canvasImgDemoSave'] = ''
                    window['canvasImgBeforeSave'] = ''
                    window['canvasImgBaseSave'] = ''
                    window['canvasVideoSave'] = ''
                    window['canvasChange'] = false
                    this.clientTopServices.changecheckDataAfterConfirm(false)
                }
                this.arrRegistration = arrAll['registration']
                this.countArrDataRegistration = this.countArrAllClientTop = this.arrRegistration.length
                this.max = this.countArrDataRegistration - 1
                const tmp: number = this.senMax / this.max
                const assign = tmp
                this.ValueAssignOneDistance = assign
                if (typeof this.arrRegistration[0]['_id'] !== 'undefined') {
                    this.arrRegistration = this.clientTopServices.changeDateStringToDecoe(this.arrRegistration)
                }
                if (this.countArrDataRegistration > 0) {
                    this.arrRegistration.sort((function(obj1, obj2) {
                        return obj1.dateStringToInit - obj2.dateStringToInit
                    }))
                    this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
                        if (infoIndex != null && infoIndex['index'] != undefined) {
                            this.index = infoIndex['index']
                            if (this.arrRegistration.length > 0) {
                                if (this.arrRegistration[this.index] != undefined) {
                                    this.arrRegistrationShow = this.arrRegistration[this.index]
                                    this.contentNote = this.arrRegistration[this.index]['note']
                                    this.timeline = this.arrRegistrationShow['dateStringToInit'] ? this.arrRegistration[this.index]['dateStringToInit'] : ''
                                    if (this.timeline != '') {
                                        const offset = new Date().getTimezoneOffset()
                                        const showdateAdd = moment(this.timeline).subtract(Math.abs(offset), 'ms').format('YYYY.MM.DD ddd')
                                        this.showDate = this.dateStart = showdateAdd
                                    }
                                }
                            } else {
                                this.isShow = false
                                this.showDate = 'Click to Select'
                                this.dateStart = undefined
                            }
                        }
                    })
                }
            } else {
                this.countArrAllClientTop = 0
                this.isShow = false
                this.showDate = 'Click to Select'
                this.dateStart = undefined
                this.arrRegistration = []
            }
        })
    }

    showModalListNote() {
        const listDataNoteTopClient = ['ModalClientDetailRegistrationComponent-listDataNoteTopClient', this.arayListNote, this.idClient, this.index]
        this.clientTopServices.emitChangeListTopImageData(listDataNoteTopClient)
    }

    createArrAllClientTop() {
        const bodyCreate = MultipleImageHelper.parseClientInitJson()
        bodyCreate['dsd'] = null
        bodyCreate['smile'] = null
        const arr = [
            bodyCreate,
        ]
        return arr
    }

    toggleTabRegistrationItem(id, event) {
        if (id === 'option_6') {
            this.smileActive = true
            this.dsdActive = false
        } else if (id === 'option_7') {
            this.smileActive = false
            this.dsdActive = true
        } else {
            this.smileActive = false
            this.dsdActive = false
        }
        this.TabRegistrationClass = id
        const emitStatus: any = {}
        if (this.option_Registration_Face == 'active') {
            emitStatus['status'] = true
            this.clientTopServices.emitChangeChangeStatus(emitStatus)
        } else {
            emitStatus['status'] = false
            this.clientTopServices.emitChangeChangeStatus(emitStatus)
        }
        const tmpTabName = this.clientTopServices.functReturnTabName()
        if (tmpTabName['tabName'] != this.tabName) {
            this.matrixServices.resetMatrix()
        }
        switch (this.TabRegistrationClass) {
            case 'option_0':
                this.tabName = 'face-all'
                this.emitTabName['tabName'] = 'face-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'option_1':
                this.tabName = 'tooth-all'
                this.emitTabName['tabName'] = 'tooth-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'option_2':
                this.tabName = 'aligner-all'
                this.emitTabName['tabName'] = 'aligner-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'option_3':
                this.tabName = 'xp-all'
                this.emitTabName['tabName'] = 'xp-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'option_4':
                this.tabName = 'other-all'
                this.emitTabName['tabName'] = 'other-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'option_5':
                this.tabName = 'movie-all'
                this.emitTabName['tabName'] = 'movie-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'option_6':
                this.tabName = 'smile'
                this.emitTabName['tabName'] = 'smile'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'option_7':
                this.tabName = 'dsd'
                this.emitTabName['tabName'] = 'dsd'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'option_8':
                this.tabName = 'dental-all'
                this.emitTabName['tabName'] = 'dental-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            default:
                this.tabName = 'tooth-all'
                this.emitTabName['tabName'] = 'tooth-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
        }

        if (this.tabName == 'dsd' || this.tabName == 'smile') {
            this.clearDsdStorage()
            this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
            this.clientTopServices.changecheckDataAfterConfirm(false)
        }
    }

    toggleProfile(event) {
        this.docIcon = (event === -1 ? 0 : -1)
        const emitStatus: any = {}
        if (this.docIcon === 0) {
            this.option_Registration_Face = 'active'
            emitStatus['status'] = true
            this.clientTopServices.emitChangeChangeStatus(emitStatus)
        } else {
            this.option_Registration_Face = 'hidden'
            emitStatus['status'] = false
            this.clientTopServices.emitChangeChangeStatus(emitStatus)
        }
    }

    prevDate(timestampAdd, day, option) {
        this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
        const assignCurenly = this.getvalChangeFromIndex(this.index)
        if (option === 'start') {
            if (this.showDate !== 'Click to Select') {
                if (day === 0) {
                    const assign = 0
                    this.checkAlertConFirmWhenNextDay(assignCurenly, assign)
                } else {
                    if (this.valChange < 0) {
                        const assign = 0
                        this.checkAlertConFirmWhenNextDay(assignCurenly, assign)
                    } else {
                        const assign = this.valChange - day
                        this.checkAlertConFirmWhenNextDay(assignCurenly, assign)
                    }
                }
            }
        }
    }

    nextDate(timestampAdd, day, option) {
        this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
        const assignCurenly = this.getvalChangeFromIndex(this.index)
        if (option === 'start') {
            if (this.showDate !== 'Click to Select') {
                if (day === 100) {
                    const assign = 100
                    this.checkAlertConFirmWhenNextDay(assignCurenly, assign)
                } else {
                    const assign = this.valChange + day
                    this.checkAlertConFirmWhenNextDay(assignCurenly, assign)
                }
            }
        }
    }

    checkAlertConFirmWhenNextDay(assignCurenly, assign) {
        const tabName: any = this.clientTopServices.getTabName()
        if (window['canvasChange']) {
            this.clientTopServices.checkChangeData = true
        }
        if (this.clientTopServices.checkChangeData === true) {
            this.changeLanguage()
            notification.confirm({
                message: this.en['alert-content'],
                title: '<b>' + this.en['alert-title'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 0) {
                        this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                        this.valChange = assignCurenly
                        this.getDateWhenChangeSliderRegister(assignCurenly)
                        this.clientTopServices.changecheckDataAfterConfirm(true)
                    } else if (i === 1) {
                        this.valChange = assign
                        this.getDateWhenChangeSliderRegister(assign)
                        const indexNext = this.getvalIndexNextFromaAssign(assign)
                        const emitChangeRefresh = ['ModalClientDetailRegistrationComponent-emitChangeRefresh', indexNext, false]
                        this.clientTopServices.emitChangeRefresh(emitChangeRefresh)
                        window['canvasChange'] = false
                    } else if (i === 2) {
                        let indexPre = this.clientTopServices.getIndex()
                        if (this.tabName == 'dsd' || this.tabName == 'smile') {
                            this.uploadDSD(indexPre, assign)
                        } else {
                            this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                            if (this.isUpdateImageSet) {
                                this.saveUpdateImageSet()
                            }
                            if (this.isChangeNodeText) {
                                this.saveUpdateNodeText()
                            }
                            this.onSave()
                            this.valChange = assign
                            this.getDateWhenChangeSliderRegister(assign)
                        }
                        window['canvasChange'] = false
                    }
                },
            })
        } else {
            this.getDateWhenChangeSliderRegister(assign)
        }
    };

    getFormattedDate(date) {
        const year = date.getFullYear()
        let month = (1 + date.getMonth()).toString()
        month = month.length > 1 ? month : '0' + month
        let day = date.getDate().toString()
        day = day.length > 1 ? day : '0' + day
        return month + '/' + day + '/' + year
    }

    compareDaySelectFollowData() {
        let arrayDateString = this.arrRegistration
        const arayDatetimepicker = $('.bootstrap-datetimepicker-widget .day')
        for (let i = 0; i <= arayDatetimepicker.length; i++) {
            const detailDatetimepicker = $(arayDatetimepicker[i]).attr('data-day')
            for (let j = 0; j < arrayDateString.length; j++) {
                const formatDateClinetVisit = new Date(arrayDateString[j].dateStringToInit)
                const formatDateClinetVisitToString = this.getFormattedDate(formatDateClinetVisit)
                if (detailDatetimepicker === formatDateClinetVisitToString) {
                    $('.bootstrap-datetimepicker-widget .day:eq(' + i + ')').css({ 'background-color': '#a6d1e0' })
                }
            }
        }
    }

    checkDatepickerLoading = () => {
        this.clientTopServices.changeActiveDatepickerAfterConfirm(true)
        this.clientTopServices.changeActiveDatepickerAfterConfirm('Show')
        this.compareDaySelectFollowData()
    }

    updateDatepicker(event, option) {        
        const assignCurenly = this.getvalChangeFromIndex(this.index)
        this.compareDaySelectFollowData()
        if (event && event['_d']) {
            const offset = new Date().getTimezoneOffset()
            const date = moment(event['_d']).format('MM/DD/YYYY')
            const dateTime0 = moment(date)
            this.timestampLast = moment(dateTime0).utc().add(Math.abs(offset), 'ms').valueOf()
            // this.timestampLast = moment(event['_d']).utc().add(Math.abs(offset), 'ms').valueOf();
            const timestampLastCheck = this.compareNewRecorndTimestampLast(this.timestampLast)
            if (window['canvasChange']) {
                this.clientTopServices.checkChangeData = true
            }
            const checkChangeData: any = this.clientTopServices.returnCheckChange()
            const checkActiveDatepickker: any = this.clientTopServices.getCheckActiveDatepickker()
            if (checkChangeData == true && checkActiveDatepickker == true) {
                this.changeLanguage()
                const checkActiveDatepickkerWhenCancel: any = this.clientTopServices.getCheckActiveDatepickkerWhenCancel()
                if (checkActiveDatepickkerWhenCancel == true) {
                    notification.confirm({
                        message: this.en['alert-content'],
                        title: '<b>' + this.en['alert-title'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i === 0) {
                                this.clientTopServices.changecheckDataAfterConfirm(true)
                                this.clientTopServices.changeActiveDatepickerAfterConfirm(true)
                                this.clientTopServices.changeActiveDatepickerAfterConfirm('not Show')
                                this.valChange = assignCurenly
                                this.getDateWhenChangeSliderRegister(assignCurenly)
                                if (timestampLastCheck === false) { // create new
                                    this.clientTopServices.emitCancelBtn(true)
                                }
                            } else if (i === 1) {  // here this is not cancelled.  1 is correct.
                                const allArrClientTop: any[] = this.clientTopServices.getAllArrClientTop()
                                if (this.pastedIndex == -1 && this.cutIndex != -1) { // discard cut SmileDesign
                                    allArrClientTop[this.cutIndex][this.tabName] = this.cutData
                                    const emitArrAll: any = {}
                                    emitArrAll['registration'] = allArrClientTop
                                    emitArrAll['checkChange'] = false
                                    this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                                    this.cutData = {}
                                    this.cutIndex = -1
                                } else if (this.pastedIndex != -1) { // discard pasted SmileDesign
                                    allArrClientTop[this.pastedIndex][this.tabName] = ''
                                    const emitArrAll: any = {}
                                    emitArrAll['registration'] = allArrClientTop
                                    emitArrAll['checkChange'] = false
                                    this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                                    this.pastedIndex = -1
                                }
                                this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                                if (this.tabName == 'dsd' || this.tabName == 'smile') {
                                    this.clientTopServices.changecheckDataAfterConfirm(false)
                                }
                                if (timestampLastCheck === false) {
                                    this.isCreate = true
                                }
                                this.getDateWhenChangeSliderRegister(this.timestampLast)
                                this.showDate = moment(event['_d']).format('YYYY.MM.DD ddd')
                                this.isShow = true
                                if (this.isCreate) {
                                    if (this.tabName == 'dsd' || this.tabName == 'smile') {
                                        this.discardDsd = true
                                    }
                                    this.onCreate(this.timestampLast)
                                } else {
                                    this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                                    const assign = this.getAssignFromaTimesTamplast(this.timestampLast)
                                    const tabName: any = this.clientTopServices.getTabName()
                                    const indexNext = this.getvalIndexNextFromaAssign(assign)
                                    const emitChangeRefresh = ['ModalClientDetailRegistrationComponent-emitChangeRefresh', indexNext, false]
                                    this.clientTopServices.emitChangeRefresh(emitChangeRefresh)
                                    this.valChange = assign
                                    this.getDateWhenChangeSliderRegister(assign)
                                }
                                window['canvasChange'] = false
                                this.cutDsd = false
                            } else if (i === 2) {
                                this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                                if (this.isUpdateImageSet) {
                                    this.saveUpdateImageSet()
                                }
                                if (this.isChangeNodeText) {
                                    this.saveUpdateNodeText()
                                }
                                if (this.tabName == 'dsd' || this.tabName == 'smile') {
                                    this.updateDsd = true
                                    this.getRecorndTime(event, timestampLastCheck)
                                } else {
                                    this.onSave()
                                    this.getRecorndTime(event, timestampLastCheck)
                                }
                                window['canvasChange'] = false
                                this.cutData = {}
                                this.cutIndex = -1
                                this.pastedIndex = -1
                            }

                        },
                    })
                }
            } else {
                this.getRecorndTime(event, timestampLastCheck)
                this.clientTopServices.changecheckDataAfterConfirm(false)
            }
            // $('.bootstrap-datetimepicker-widget').hide();
        }
    }

    getRecorndTime(event, timestampLastCheck) {
        if (timestampLastCheck === false) {
            this.isCreate = true
            this.createDsd = this.tabName == 'dsd' || this.tabName == 'smile'
        }
        let date1 = this.showDate.replace(/[^\d.]/g, '')
        let d1 = moment(date1).format('X')
        this.showDate = moment(event['_d']).format('YYYY.MM.DD ddd')
        let date2 = this.showDate.replace(/[^\d.]/g, '')
        let d2 = moment(date2).format('X')
        this.isShow = true
        let saveIndex = this.index
        // if (d1 > d2) {
        //     saveIndex = this.index + 1;
        // }
        if (this.isCreate) {
            if ((this.tabName == 'dsd' || this.tabName == 'smile') && this.clientTopServices.returnCheckChange()) {
                this.uploadDSD(saveIndex, -1)
            } else {
                this.onCreate(this.timestampLast)
            }
        } else {
            if ((this.tabName == 'dsd' || this.tabName == 'smile') && this.updateDsd) {
                const slideValue = this.findSliderValue(d2)
                this.uploadDSD(this.index, slideValue)
            } else {
                this.getDateWhenChangeSliderRegister(this.timestampLast)
            }
        }
    }

    findSliderValue(timestamp) {
        if (this.arrRegistration && this.arrRegistration.length > 1) {
            const found = this.arrRegistration.findIndex(function(e) {
                const date = moment(e.dateStringToInit).startOf('day').format('X')
                return moment(e.dateStringToInit).startOf('day').format('X') == timestamp
            })
            if (found != -1) {
                const sliderValue = found * 100 / (this.arrRegistration.length - 1)
                return sliderValue
            }
        }
        return 0
    }


    onCreate(timestampLast) {
        if ((this.tabName == 'dsd' || this.tabName == 'smile') && !this.createDsd) {
            this.clientTopServices.canvasModalLoading$.next({ show: true, status: 'create' })
        }
        const timestampLastCheck = this.compareNewRecorndTimestampLast(this.timestampLast)
        const tabName: any = this.clientTopServices.getTabName()
        const arrTmp: any[] = this.createArrAllClientTop()
        const bodyCreate: any = arrTmp[0]
        bodyCreate['dateString'] = moment(this.timestampLast).format('YYYY-MM-DD')
        bodyCreate['clientId'] = this.idClient
        const result = '{"clientId":"' + this.idClient + '"}'
        const clientVisit: any = {}
        clientVisit[result] = true
        const status: any = {
            clientVisit: {
                paths: clientVisit,
            },
            clinic: {
                paths: {
                    '{}': true,
                },
            },
            setting: {
                map: {
                    common: true,
                },
                paths: {
                    '{}': true,
                },
            },
            staff: {
                paths: {
                    '{"roles":"cordinator"}': true,
                    '{"roles":"doctor"}': true,
                    '{}': true,
                },
            },
        }
        delete bodyCreate['_id']
        const resourceData: any = {
            actions: [
                {
                    type: 'create',
                    collection: 'clientVisit',
                    value: bodyCreate,
                },
            ],
            status: status,
        }
        const newValueChange = this.getNewVallueChange('add')
        if (timestampLastCheck == false) {
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                    this.valChange = newValueChange
                    this.clientTopServices.emitChangeValueSlider(this.valChange)
                    this.isCreate = false
                    this.arrRegistration = success['response']['clientVisit']['paths']['' + result]
                    this.countArrDataRegistration = success['response']['clientVisit']['paths']['' + result].length
                    this.max = this.countArrDataRegistration - 1
                    const tmp: number = this.senMax / this.max
                    // const assign = Math.round(tmp);
                    const assign = tmp
                    this.ValueAssignOneDistance = assign
                    if (this.countArrDataRegistration > 0) {
                        this.arrRegistration = this.clientTopServices.changeDateStringToDecoe(this.arrRegistration)
                        this.arrRegistration.sort((function(obj1, obj2) {
                            return obj1.dateStringToInit - obj2.dateStringToInit
                        }))
                        const emitArr: any = {}
                        emitArr['registration'] = this.arrRegistration
                        emitArr['checkChange'] = false
                        if ((this.tabName == 'dsd' || this.tabName == 'smile') && this.createDsd) {
                            this.clientTopServices.canvasModalLoading$.next({ show: false, status: 'save' })
                        } else {
                            this.clientTopServices.canvasModalLoading$.next({ show: false, status: 'create' })
                        }
                        this.clientTopServices.emitChangeAllArrClientTop(emitArr)
                        const indexCreate = this.getvalIndexNextFromaTimeTamplast(timestampLast)
                        if (this.countArrDataRegistration == 1) {
                            this.index = 0
                        } else {
                            this.index = indexCreate
                        }
                        const emitIndex: any = {}
                        if (this.tabName == 'dsd' || this.tabName == 'smile') {
                            if (this.index == 0 || this.discardDsd) {
                                emitIndex['index'] = this.index
                                emitIndex['oldIndex'] = 0
                                this.discardDsd = false
                            }
                        } else {
                            emitIndex['index'] = this.index
                        }
                        this.getDateWhenChangeSliderRegister(timestampLast)
                        this.clientTopServices.emitChangeIndex(emitIndex)
                        this.arrRegistrationShow = this.arrRegistration[this.index]
                        if (this.arrRegistrationShow != undefined) {
                            this.timeline = this.arrRegistrationShow['dateStringToInit'] ? this.arrRegistration[this.index]['dateStringToInit'] : ''
                        }
                        if (this.timeline != '') {
                            const offset = new Date().getTimezoneOffset()
                            const showdateAdd = moment(this.timeline).subtract(Math.abs(offset), 'ms').format('YYYY.MM.DD ddd')
                            this.showDate = this.dateStart = showdateAdd
                        }
                        const emitIsCreated: any = {}
                        emitIsCreated['create'] = 'create'
                        emitIsCreated['tabName'] = tabName
                        emitIsCreated['page'] = 'registration'
                        this.clientTopServices.emitChangeIsCreated(emitIsCreated)
                    }
                })
            })
        }
    }

    showDatepickerIcon() {
        (<any>$('[a2e-datetimepicker]').first()).datetimepicker('show')
        $('.bootstrap-datetimepicker-widget').show();
        this.checkDatepickerLoading()
        //     (<any>$('[a2e-datetimepicker]').first()).datetimepicker('show');
        //     this.compareDaySelectFollowData();
        //     $('.bootstrap-datetimepicker-widget').css({ 'z-index': 9999 });
    }

    getNewVallueChange(type) {
        const valueChange = this.valChange
        let newValueChange: any = 0
        const valueNow = Math.round(valueChange * this.max / this.senMax)
        if (type == 'add') {
            newValueChange = this.senMax
        } else if (type == 'sub') {
            const newMax = this.max - 1
            if (newMax == 0) {
                newValueChange = 0
            } else {
                newValueChange = valueNow * this.senMax / newMax
            }
        }
        return Math.round(newValueChange)
    }

    saveAfterDeleteRecornd() {
        this.changeLanguage()
        if (this.countArrAllClientTop > 0) {
            notification.confirm({
                message: this.en['alert-content-2'],
                title: '<b>' + this.en['alert-remove'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        if (this.tabName == 'dsd' || this.tabName == 'smile') {
                            window['canvasVideoCopy'] = ''
                            window['canvasChange'] = false
                            window['canvasSave'] = ''
                            window['canvasImgDemoSave'] = ''
                            window['canvasImgBeforeSave'] = ''
                            window['canvasImgBaseSave'] = ''
                            window['canvasVideoSave'] = ''
                            this.clientTopServices.changecheckDataAfterConfirm(false)
                        }

                        this.deleteRecornd()
                    }
                },
            })
        }
    }

    deleteRecornd() {
        if (this.tabName == 'dsd' || this.tabName == 'smile') {
            this.clientTopServices.canvasModalLoading$.next({ show: true, status: 'delete' })
        }
        let resourceData: any = {}
        const arrSaveClientTop: any[] = this.clientTopServices.getAllArrClientTop()
        const index = this.clientTopServices.getIndex()
        let jsonNow: any
        let id: any = ''
        const result = '{"clientId":"' + this.idClient + '"}'
        const clientVisit: any = {}
        clientVisit[result] = true
        const status: any = {
            clientVisit: {
                paths: clientVisit,
            },
        }
        if (arrSaveClientTop[index]) {
            jsonNow = arrSaveClientTop[index]
            id = jsonNow['_id']
            resourceData = this.restApi.makeResourceObject({
                actions: [
                    {
                        type: 'remove',
                        collection: 'clientVisit',
                        id: id,
                    },
                ],
                status: status,
            })
            const newValueChange = this.getNewVallueChange('sub')
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                    this.arrRegistration = success['response']['clientVisit']['paths']['' + result]
                    this._sharedService.emitChange(['removeListOfImage', this.arrRegistration])
                    const emitArrAll: any = {}

                    if (this.arrRegistration.length <= 0) {
                        const temp = this.TabRegistrationClass
                        this.TabRegistrationClass = ''
                        setTimeout(() => {
                            this.TabRegistrationClass = temp
                        }, 200);

                    }
                    this.arrRegistration.sort((function(obj1, obj2) {
                        return obj1.dateString.localeCompare(obj2.dateString);
                    }))
                    emitArrAll['registration'] = this.arrRegistration
                    emitArrAll['checkChange'] = false
                    this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)

                    this.countArrDataRegistration = this.countArrAllClientTop = success['response']['clientVisit']['paths']['' + result].length
                    const tabName: any = this.clientTopServices.getTabName()
                    const emitIndex: any = {}
                    const ind: any = this.clientTopServices.getIndex()
                    if (ind == 0) {
                        this.index = 0
                        emitIndex['index'] = this.index
                        if (tabName == 'dsd' || tabName == 'smile') {
                            emitIndex['oldIndex'] = ind
                        }
                    } else {
                        this.index = ind - 1
                        emitIndex['index'] = this.index
                    }

                    let imageFrontSmile = this.getFrontSmileToAvatar(this.arrRegistration)
                    if (imageFrontSmile == undefined) {
                        imageFrontSmile = { id: '' }
                    }
                    if (imageFrontSmile !== undefined) {
                        if (typeof this.faceImage === 'undefined') {
                            this.callApiUpdateFaceImage(imageFrontSmile)
                        } else if (this.faceImage !== '') {
                            if (this.faceImage['id'] !== imageFrontSmile['id']) {
                                this.callApiUpdateFaceImage(imageFrontSmile)
                            } else if (imageFrontSmile['matrix'] != undefined && this.faceImage['matrix'] !== imageFrontSmile['matrix'].toString()) {
                                this.callApiUpdateFaceImage(imageFrontSmile)
                            }
                        }
                    }
                    
                    this.valChange = newValueChange
                    this.clientTopServices.emitChangeIndex(emitIndex)
                    this.clientTopServices.emitChangeValueSlider(this.valChange)
                    this.max = this.countArrDataRegistration - 1
                    const tmp: number = this.senMax / this.max
                    // const assign = Math.round(tmp);
                    const assign = tmp
                    this.ValueAssignOneDistance = assign
                    if (typeof this.arrRegistration[0] !== 'undefined') {
                        if (typeof this.arrRegistration[0]['_id'] !== 'undefined') {
                            this.arrRegistration = this.clientTopServices.changeDateStringToDecoe(this.arrRegistration)
                        }
                    }
                    if (this.countArrDataRegistration > 0) {
                        // this.arrRegistration.sort((function(obj1, obj2) {
                        //     return obj1.dateString.localeCompare(obj2.dateString);
                        // }))
                        this.arrRegistration.sort((function(obj1, obj2) {
                            return obj1.dateStringToInit - obj2.dateStringToInit
                        }))
                        this.arrRegistrationShow = this.arrRegistration[this.index]
                        this.timeline = this.arrRegistration[this.index]['dateStringToInit'] ? this.arrRegistration[this.index]['dateStringToInit'] : ''
                        if (this.timeline !== '') {
                            const offset = new Date().getTimezoneOffset()
                            const showdateAdd = moment(this.timeline).subtract(Math.abs(offset), 'ms').format('YYYY.MM.DD ddd')
                            this.showDate = this.dateStart = showdateAdd
                        }
                    }
                    const emitIsCreated: any = {}
                    emitIsCreated['create'] = 'create'
                    emitIsCreated['tabName'] = tabName
                    emitIsCreated['page'] = 'registration'
                    this.clientTopServices.emitChangeIsCreated(emitIsCreated)
                    if (this.tabName == 'dsd' || this.tabName == 'smile') {
                        this.clientTopServices.canvasModalLoading$.next({ show: false, status: 'delete' })
                    }
                }, error1 => {
                })
            })
        }
    }

    selectListImageTop() {
        const listDataImageTopClient = ['listDataImageTopClient', this.arrRegistration, this.idClient, this.index, this.arayListNote]
        this.clientTopServices.emitChangeListTopImageData(listDataImageTopClient)
    }


    getDateWhenChangeSliderRegister(assign) {
        const arrayVlauseAllDate: any[] = this.createArraySlideRange()
        if (assign !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                if (assign == arrayVlauseAllDate[j]['locationValue'] || Math.round(assign) == Math.round(arrayVlauseAllDate[j]['locationValue'])) {
                    const showdateAdd = moment(arrayVlauseAllDate[j]['dateInit']).format('YYYY.MM.DD ddd')
                    this.showDate = this.dateStart = showdateAdd
                    this.valChange = assign
                    this.index = j
                    this.arrRegistrationShow = this.arrRegistration[this.index]
                    const emitIndex: any = {}
                    emitIndex['index'] = this.index
                    this.clientTopServices.emitChangeIndex(emitIndex)
                    break
                } else if (assign === arrayVlauseAllDate[j]['dateInit']) {
                    const showdateAdd = moment(arrayVlauseAllDate[j]['dateInit']).format('YYYY.MM.DD ddd')
                    this.showDate = this.dateStart = showdateAdd
                    this.valChange = arrayVlauseAllDate[j]['locationValue']
                    this.index = j
                    this.arrRegistrationShow = this.arrRegistration[this.index]
                    const emitIndex: any = {}
                    emitIndex['index'] = this.index
                    if (this.createDsd) {
                        emitIndex['oldIndex'] = 0
                        this.createDsd = false
                    }
                    this.clientTopServices.emitChangeIndex(emitIndex)
                    break
                }
            }
            const ArrayValueNote = ['ModalClientDetailRegistrationComponent-valueNote', this.index, this.valChangeNodeText]
            this.clientTopServices.emitChangeIndexToGetNote(ArrayValueNote)
        }
    }

    changeValueEx1SliderRegister() {
        const tabName: any = this.clientTopServices.getTabName()
        let assignCurenly: any = 0
        this.unsubSlider = this.clientTopServices.changeEmittedSlider$.subscribe(res => {
            const activePage = this.clientTopServices.page
            if (res != null && res['sliderClientTop'] != undefined && activePage == 'registration') {
                this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
                    if (infoIndex != null && infoIndex != undefined && infoIndex['index'] != undefined) {
                        this.index = infoIndex['index']
                        assignCurenly = this.getvalChangeFromIndex(this.index)
                    }
                })
                if (window['canvasChange']) {
                    this.clientTopServices.checkChangeData = true
                }
                if (this.clientTopServices.checkChangeData === true) {
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content'],
                        title: '<b>' + this.en['alert-title'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i === 0) {
                                this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                                this.valChange = assignCurenly
                                this.getDateWhenChangeSliderRegister(assignCurenly)
                                this.clientTopServices.changecheckDataAfterConfirm(true)
                                this.clientTopServices.emitCancelBtn(true)
                            } else if (i === 1) {
                                this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                                const assign = this.getAssignCalculateChange(res['sliderClientTop'])
                                const indexNext = this.getvalIndexNextFromaAssign(assign)
                                const emitChangeRefresh = ['ModalClientDetailRegistrationComponent-emitChangeRefresh', indexNext, false]
                                this.clientTopServices.emitChangeRefresh(emitChangeRefresh)
                                this.valChange = assign
                                this.getDateWhenChangeSliderRegister(assign)
                                window['canvasChange'] = false
                            } else if (i === 2) {
                                let indexPre = this.clientTopServices.getIndex()
                                if (this.tabName == 'dsd' || this.tabName == 'smile') {
                                    this.uploadDSD(indexPre, res['sliderClientTop'])
                                } else {
                                    this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                                    if (this.isUpdateImageSet) {
                                        this.saveUpdateImageSet()
                                    }
                                    if (this.isChangeNodeText) {
                                        this.saveUpdateNodeText()
                                    }
                                    this.onSave()
                                    const assign = this.getAssignCalculateChange(res['sliderClientTop'])
                                    this.valChange = assign
                                    this.getDateWhenChangeSliderRegister(assign)
                                }
                                window['canvasChange'] = false
                            }
                        },
                    })
                } else {
                    const assign = this.getAssignCalculateChange(res['sliderClientTop'])
                    this.valChange = assign
                    this.getDateWhenChangeSliderRegister(assign)
                    this.clientTopServices.changecheckDataAfterConfirm(false)
                }
            }
        })
    }

    saveUpdateNodeText() {
        const valNodeText = this.contentNote
        const clientId = {}
        const result = this.idClient
        clientId[result] = true
        const resourceData = {
            actions: [
                {
                    collection: 'clientVisit',
                    id: this.arrRegistration[this.index]['_id'],
                    type: 'update',
                    value: {
                        note: valNodeText,
                    },
                },
            ],
            status: {
                client: {
                    map: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const ArrayValueNote = ['ModalClientDetailRegistrationComponent-valueNoteBeforeOld', this.indexBeforChange, this.valChangeNodeText]
                this.clientTopServices.emitChange(ArrayValueNote)
            })
        })
    }

    saveUpdateImageSet() {
        const imageSetUpdate = this.arayListNote
        const clientId = {}
        const result = this.idClient
        clientId[result] = true
        const resourceData = {
            actions: [
                {
                    collection: 'client',
                    id: this.idClient,
                    type: 'update',
                    value: {
                        imageSet: imageSetUpdate,
                    },
                },
            ],
            status: {
                client: {
                    map: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            console.log('saveUpdateImageSet')
            this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arayListNote = success['response']['client']['map'][result]['imageSet']
                const emitNoteList = ['ModalClientDetailRegistrationComponent-arrayNoteList', this.arayListNote]
                this.clientTopServices.emitChangeNoteList(emitNoteList)
            })
        })
    }

    createArraySlideRange() {
        const arrayVlauseAllDate = []
        const arrayDateString: any[] = this.arrRegistration
        if (arrayDateString.length > 0) {
            if (arrayDateString.length === 1) {
                arrayVlauseAllDate.push({
                    location: 0,
                    locationValue: 0,
                    dateInit: arrayDateString[0].dateStringToInit,
                    dateText: arrayDateString[0].dateString,
                })
            } else {
                for (let i = 0; i < arrayDateString.length; i++) {
                    const tmp: number = this.senMax / this.max
                    const assignCalculate = tmp
                    const valueInChangeSlider = i * assignCalculate
                    arrayVlauseAllDate.push({
                        location: i,
                        locationValue: valueInChangeSlider,
                        dateInit: arrayDateString[i].dateStringToInit,
                        dateText: arrayDateString[i].dateString,
                    })
                }
                return arrayVlauseAllDate
            }
        }
        return arrayVlauseAllDate
    }

    getvalChangeFromIndex(index) {
        const arrayVlauseAllDate = this.createArraySlideRange()
        if (index !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                if (index == arrayVlauseAllDate[j]['location']) {
                    return arrayVlauseAllDate[j]['locationValue']
                }
            }
            return null
        }
    }

    getvalIndexNextFromaAssign(assign) {
        const arrayVlauseAllDate = this.createArraySlideRange()
        if (assign !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                if (assign == arrayVlauseAllDate[j]['locationValue']) {
                    return arrayVlauseAllDate[j]['location']
                } else if (assign === 100) {
                    return arrayVlauseAllDate[arrayVlauseAllDate.length - 1]['location']
                }
            }
            return null
        }
    }

    getAssignFromaTimesTamplast(timestampLast) {
        const arrayVlauseAllDate = this.createArraySlideRange()
        if (timestampLast !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                if (timestampLast == arrayVlauseAllDate[j]['dateInit']) {
                    return arrayVlauseAllDate[j]['locationValue']
                }
            }
            return null
        }
    }

    getvalIndexNextFromaTimeTamplast(timestampLast) {
        const arrayVlauseAllDate = this.createArraySlideRange()
        if (timestampLast !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                if (timestampLast == arrayVlauseAllDate[j]['dateInit']) {
                    return arrayVlauseAllDate[j]['location']
                }
            }
            return null
        }
    }

    compareNewRecorndTimestampLast(timestampLast) {
        const arrayVlauseAllDate = this.createArraySlideRange()
        const arrCheck = []
        if (timestampLast !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                arrCheck.push(arrayVlauseAllDate[j]['dateInit'])
            }
            if (arrCheck.indexOf(timestampLast) > -1) {
                return true
            }
            return false
        }
    }


    getAssignCalculateChange(resSliderClientTop) {
        const value: any = resSliderClientTop
        const tmp: number = (value / this.senMax) * this.max
        this.index = Math.round(tmp)
        const tmpEarch: number = this.senMax / this.max
        const assignCalculate = tmpEarch
        const assignLocal = this.index * assignCalculate
        return assignLocal
    }

    getArrCopy() {
        this.clientTopServices.changeEmittedArrCopy$.subscribe(res => {
            if (res != null) {
                this.showPaste = true
            } else {
                this.showPaste = false
            }
        })
    }

    onCopy() {
        this.count = 0
        const allArrClientTop: any[] = this.clientTopServices.getAllArrClientTop()
        if (allArrClientTop != undefined && allArrClientTop.length > 0) {
            const tabName = this.clientTopServices.getTabName()
            if (this.count == 0) {
                // this.clientTopServices.changeEmittedIndex$.subscribe(index => {
                const ind = this.clientTopServices.getIndex()
                const tmp: any[] = allArrClientTop[ind][tabName]
                const emitArrCopy: any = {}
                if (tabName != 'dsd' && tabName != 'smile') {
                    const arrCopy: any[] = []
                    tmp.forEach((el, i) => {
                        arrCopy[i] = el
                    })
                    const str: string = tabName
                    if (str.includes('movie')) {
                        emitArrCopy['tabName'] = 'movie'
                    } else {
                        emitArrCopy['tabName'] = 'all'
                    }
                    emitArrCopy['arrCopy'] = arrCopy
                } else {
                    document.getElementById('copy-canvas-btn').click()
                    const canvas = window['canvasCopy']
                    if (canvas && canvas != 'undefined') {
                        if (!allArrClientTop[ind][tabName]) {
                            allArrClientTop[ind][tabName] = {}
                        }
                        if (tabName == 'smile') {
                            allArrClientTop[ind][tabName].canvas = canvas
                            allArrClientTop[ind][tabName].canvasImgBase = window['canvasImgBaseCopy']
                            allArrClientTop[ind][tabName].canvasImgDemo = window['canvasImgDemoCopy']
                        } else {
                            allArrClientTop[ind][tabName].canvas = canvas
                            allArrClientTop[ind][tabName].canvasImgBase = window['canvasImgBaseCopy']
                            allArrClientTop[ind][tabName].canvasImgBefore = window['canvasImgBeforeCopy']
                            allArrClientTop[ind][tabName].canvasImgDemo = window['canvasImgDemoCopy']
                            const canvasVideo = window['canvasVideoCopy']
                            if (canvasVideo && canvasVideo != 'undefined') {
                                const part1 = canvasVideo.split('?AWSAccessKeyId')[0]
                                const part1Arr = part1.split('/')
                                allArrClientTop[ind][tabName].canvasVideo = part1Arr[part1Arr.length - 1]
                            } else {
                                allArrClientTop[ind][tabName].canvasVideo = ''
                            }
                        }
                        window['canvasCopy'] = ''
                        window['canvasImgBaseCopy'] = ''
                        window['canvasImgBeforeCopy'] = ''
                        window['canvasImgDemoCopy'] = ''
                        window['canvasVideoCopy'] = ''
                        emitArrCopy['tabName'] = tabName
                        emitArrCopy['arrCopy'] = allArrClientTop[ind][tabName]
                    }
                }
                this.clientTopServices.emitChangeArrCopy(emitArrCopy)
                this.showPaste = true
                this.count += 1
                // });
            }
        }
    }

    onCut() {
        this.isCut = true
        this.count = 0
        const allArrClientTop: any[] = this.clientTopServices.getAllArrClientTop()
        if (allArrClientTop != undefined && allArrClientTop.length > 0) {
            const tabName = this.clientTopServices.getTabName()
            if (this.count == 0) {
                if (tabName != 'dsd' && tabName != 'smile') {
                    const ind = this.clientTopServices.getIndex()
                    const arrNewCut: any = [
                        { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },
                    ]
                    const arrCopy: any[] = allArrClientTop[ind][tabName]
                    const emitArrCopy: any = {}
                    emitArrCopy['arrCopy'] = arrCopy
                    emitArrCopy['tabName'] = this.tabName
                    emitArrCopy['onCut'] = 'cut'
                    this.clientTopServices.emitChangeArrCopy(emitArrCopy)

                    allArrClientTop[ind][tabName] = arrNewCut
                    //edit 15/3/21 check exits image(hashcode) 
                    let checkEmpty: boolean = false;
                    if(arrCopy != undefined && arrCopy.length > 0){
                        arrCopy.forEach(arr => {
                            if(arr != null && arr != undefined && arr['id'] != ''){
                                checkEmpty = true;
                            }
                        });
                    }
                    const jsonTmp: any = {}
                    jsonTmp['id'] = ''
                    this.showPaste = true
                    if(checkEmpty) {
                        switch (tabName) {
                            case 'face-1':
                                allArrClientTop[ind]['face-all'][0] = jsonTmp
                                break
                            case 'face-2':
                                allArrClientTop[ind]['face-all'][1] = jsonTmp
                                break
                            case 'face-3':
                                allArrClientTop[ind]['face-all'][2] = jsonTmp
                                break
                            case 'face-4':
                                allArrClientTop[ind]['face-all'][3] = jsonTmp
                                break
                            case 'face-5':
                                allArrClientTop[ind]['face-all'][4] = jsonTmp
                                break
                            case 'face-6':
                                allArrClientTop[ind]['face-all'][5] = jsonTmp
                                break
                            case 'face-all':
                                arrCopy.forEach((el, i) => {
                                    switch (i) {
                                        case 0:
                                            allArrClientTop[ind]['face-1'][0] = jsonTmp
                                            break
                                        case 1:
                                            allArrClientTop[ind]['face-2'][0] = jsonTmp
                                            break
                                        case 2:
                                            allArrClientTop[ind]['face-3'][0] = jsonTmp
                                            break
                                        case 3:
                                            allArrClientTop[ind]['face-4'][0] = jsonTmp
                                            break
                                        case 4:
                                            allArrClientTop[ind]['face-5'][0] = jsonTmp
                                            break
                                        case 5:
                                            allArrClientTop[ind]['face-6'][0] = jsonTmp
                                            break
                                        default:
                                            break
                                    }
                                })
                                break
                            case 'tooth-right':
                                allArrClientTop[ind]['tooth-all'][0] = jsonTmp
                                break
                            case 'tooth-front':
                                allArrClientTop[ind]['tooth-all'][1] = jsonTmp
                                break
                            case 'tooth-left':
                                allArrClientTop[ind]['tooth-all'][2] = jsonTmp
                                break
                            case 'tooth-upper':
                                allArrClientTop[ind]['tooth-all'][3] = jsonTmp
                                break
                            case 'tooth-overjet':
                                allArrClientTop[ind]['tooth-all'][4] = jsonTmp
                                break
                            case 'tooth-lower':
                                allArrClientTop[ind]['tooth-all'][5] = jsonTmp
                                break
                            case 'tooth-all':
                                arrCopy.forEach((el, i) => {
                                    switch (i) {
                                        case 0:
                                            allArrClientTop[ind]['tooth-right'][0] = jsonTmp
                                            break
                                        case 1:
                                            allArrClientTop[ind]['tooth-front'][0] = jsonTmp
                                            break
                                        case 2:
                                            allArrClientTop[ind]['tooth-left'][0] = jsonTmp
                                            break
                                        case 3:
                                            allArrClientTop[ind]['tooth-upper'][0] = jsonTmp
                                            break
                                        case 4:
                                            allArrClientTop[ind]['tooth-overjet'][0] = jsonTmp
                                            break
                                        case 5:
                                            allArrClientTop[ind]['tooth-lower'][0] = jsonTmp
                                            break
                                        default:
                                            break
                                    }
                                })
                                break
                            case 'aligner-right':
                                allArrClientTop[ind]['aligner-all'][0] = jsonTmp
                                break
                            case 'aligner-front':
                                allArrClientTop[ind]['aligner-all'][1] = jsonTmp
                                break
                            case 'aligner-left':
                                allArrClientTop[ind]['aligner-all'][2] = jsonTmp
                                break
                            case 'aligner-upper':
                                allArrClientTop[ind]['aligner-all'][3] = jsonTmp
                                break
                            case 'aligner-overjet':
                                allArrClientTop[ind]['aligner-all'][4] = jsonTmp
                                break
                            case 'aligner-lower':
                                allArrClientTop[ind]['aligner-all'][5] = jsonTmp
                                break
                            case 'aligner-all':
                                arrCopy.forEach((el, i) => {
                                    switch (i) {
                                        case 0:
                                            allArrClientTop[ind]['aligner-right'][0] = jsonTmp
                                            break
                                        case 1:
                                            allArrClientTop[ind]['aligner-front'][0] = jsonTmp
                                            break
                                        case 2:
                                            allArrClientTop[ind]['aligner-left'][0] = jsonTmp
                                            break
                                        case 3:
                                            allArrClientTop[ind]['aligner-upper'][0] = jsonTmp
                                            break
                                        case 4:
                                            allArrClientTop[ind]['aligner-overjet'][0] = jsonTmp
                                            break
                                        case 5:
                                            allArrClientTop[ind]['aligner-lower'][0] = jsonTmp
                                            break
                                        default:
                                            break
                                    }
                                })
                                break
                            case 'movie-1':
                                allArrClientTop[ind]['movie-all'][0] = jsonTmp
                                break
                            case 'movie-2':
                                allArrClientTop[ind]['movie-all'][1] = jsonTmp
                                break
                            case 'movie-3':
                                allArrClientTop[ind]['movie-all'][2] = jsonTmp
                                break
                            case 'movie-4':
                                allArrClientTop[ind]['movie-all'][3] = jsonTmp
                                break
                            case 'movie-5':
                                allArrClientTop[ind]['movie-all'][4] = jsonTmp
                                break
                            case 'movie-6':
                                allArrClientTop[ind]['movie-all'][5] = jsonTmp
                                break
                            case 'movie-all':
                                arrCopy.forEach((el, i) => {
                                    switch (i) {
                                        case 0:
                                            allArrClientTop[ind]['movie-1'][0] = jsonTmp
                                            break
                                        case 1:
                                            allArrClientTop[ind]['movie-2'][0] = jsonTmp
                                            break
                                        case 2:
                                            allArrClientTop[ind]['movie-3'][0] = jsonTmp
                                            break
                                        case 3:
                                            allArrClientTop[ind]['movie-4'][0] = jsonTmp
                                            break
                                        case 4:
                                            allArrClientTop[ind]['movie-5'][0] = jsonTmp
                                            break
                                        case 5:
                                            allArrClientTop[ind]['movie-6'][0] = jsonTmp
                                            break
                                        default:
                                            break
                                    }
                                })
                                break
                            case 'other-1':
                                allArrClientTop[ind]['other-all'][0] = jsonTmp
                                break
                            case 'other-2':
                                allArrClientTop[ind]['other-all'][1] = jsonTmp
                                break
                            case 'other-3':
                                allArrClientTop[ind]['other-all'][2] = jsonTmp
                                break
                            case 'other-4':
                                allArrClientTop[ind]['other-all'][3] = jsonTmp
                                break
                            case 'other-5':
                                allArrClientTop[ind]['other-all'][4] = jsonTmp
                                break
                            case 'other-6':
                                allArrClientTop[ind]['other-all'][5] = jsonTmp
                                break
                            case 'other-all':
                                arrCopy.forEach((el, i) => {
                                    switch (i) {
                                        case 0:
                                            allArrClientTop[ind]['other-1'][0] = jsonTmp
                                            break
                                        case 1:
                                            allArrClientTop[ind]['other-2'][0] = jsonTmp
                                            break
                                        case 2:
                                            allArrClientTop[ind]['other-3'][0] = jsonTmp
                                            break
                                        case 3:
                                            allArrClientTop[ind]['other-4'][0] = jsonTmp
                                            break
                                        case 4:
                                            allArrClientTop[ind]['other-5'][0] = jsonTmp
                                            break
                                        case 5:
                                            allArrClientTop[ind]['other-6'][0] = jsonTmp
                                            break
                                        default:
                                            break
                                    }
                                })
                                break
                            case 'xp-1':
                                allArrClientTop[ind]['xp-all'][0] = jsonTmp
                                break
                            case 'xp-2':
                                allArrClientTop[ind]['xp-all'][1] = jsonTmp
                                break
                            case 'xp-3':
                                allArrClientTop[ind]['xp-all'][2] = jsonTmp
                                break
                            case 'xp-4':
                                allArrClientTop[ind]['xp-all'][3] = jsonTmp
                                break
                            case 'xp-5':
                                allArrClientTop[ind]['xp-all'][4] = jsonTmp
                                break
                            case 'xp-6':
                                allArrClientTop[ind]['xp-all'][5] = jsonTmp
                                break
                            case 'xp-all':
                                arrCopy.forEach((el, i) => {
                                    switch (i) {
                                        case 0:
                                            allArrClientTop[ind]['xp-1'][0] = jsonTmp
                                            break
                                        case 1:
                                            allArrClientTop[ind]['xp-2'][0] = jsonTmp
                                            break
                                        case 2:
                                            allArrClientTop[ind]['xp-3'][0] = jsonTmp
                                            break
                                        case 3:
                                            allArrClientTop[ind]['xp-4'][0] = jsonTmp
                                            break
                                        case 4:
                                            allArrClientTop[ind]['xp-5'][0] = jsonTmp
                                            break
                                        case 5:
                                            allArrClientTop[ind]['xp-6'][0] = jsonTmp
                                            break
                                        default:
                                            break
                                    }
                                })
                                break
                            default:
                                break
                        }
                    }
                    const emitArrAll: any = {}
                    emitArrAll['registration'] = allArrClientTop
                    emitArrAll['checkChange'] = true
                    this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                } else {
                    this.cutDsd = true
                    const ind = this.clientTopServices.getIndex()
                    document.getElementById('copy-canvas-btn').click()
                    const canvas = window['canvasCopy']
                    if (canvas && canvas != 'undefined') {
                        if (!allArrClientTop[ind][tabName]) {
                            allArrClientTop[ind][tabName] = {}
                        }
                        if (tabName == 'smile') {
                            allArrClientTop[ind][tabName].canvas = canvas
                            allArrClientTop[ind][tabName].canvasImgBase = window['canvasImgBaseCopy']
                            allArrClientTop[ind][tabName].canvasImgDemo = window['canvasImgDemoCopy']
                        } else {
                            allArrClientTop[ind][tabName].canvas = canvas
                            allArrClientTop[ind][tabName].canvasImgBase = window['canvasImgBaseCopy']
                            allArrClientTop[ind][tabName].canvasImgBefore = window['canvasImgBeforeCopy']
                            allArrClientTop[ind][tabName].canvasImgDemo = window['canvasImgDemoCopy']
                            const canvasVideo = window['canvasVideoCopy']
                            if (canvasVideo && canvasVideo != 'undefined') {
                                const part1 = canvasVideo.split('?AWSAccessKeyId')[0]
                                const part1Arr = part1.split('/')
                                allArrClientTop[ind][tabName].canvasVideo = part1Arr[part1Arr.length - 1]
                            } else {
                                allArrClientTop[ind][tabName].canvasVideo = ''
                            }
                        }
                        window['canvasCopy'] = ''
                        window['canvasImgBaseCopy'] = ''
                        window['canvasImgBeforeCopy'] = ''
                        window['canvasImgDemoCopy'] = ''
                        window['canvasVideoCopy'] = ''
                        const emitArrCopy: any = {}
                        emitArrCopy['arrCopy'] = allArrClientTop[ind][tabName]
                        emitArrCopy['tabName'] = this.tabName
                        emitArrCopy['onCut'] = 'cut'
                        this.clientTopServices.emitChangeArrCopy(emitArrCopy)
                        this.cutData = $.extend({}, allArrClientTop[ind][tabName])
                        this.cutIndex = ind
                    }

                    // update current record
                    allArrClientTop[ind][tabName] = ''
                    const emitArrAll: any = {}
                    emitArrAll['registration'] = allArrClientTop
                    emitArrAll['checkChange'] = true
                    this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                    this.showPaste = true
                }
                this.count += 1
            }
        }
    }

    onPaste() {
        this.count = 0
        this.arrStyle = []
        const emitArrCopy: any = this.clientTopServices.getArrCopy()
        if (emitArrCopy != null && emitArrCopy['arrCopy'] != undefined) {
            const arrCopy: any[] = emitArrCopy['arrCopy']
            const tab: any = emitArrCopy['tabName']
            const tabName: string = this.clientTopServices.getTabName()
            if (tabName != 'dsd' && tabName != 'smile') {
                emitArrCopy['tabPaste'] = tabName
                if (tab == 'movie') {
                    if (tabName.includes(tab)) {
                        if (arrCopy != undefined && arrCopy.length > 0) {
                            const ind = this.clientTopServices.getIndex()
                            // this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(allArr => {
                            const allArrClientTop: any[] = this.clientTopServices.getAllArrClientTop()
                            if (this.count == 0) {
                                if (allArrClientTop != undefined && allArrClientTop.length > 0) {
                                    arrCopy.forEach((el, i) => {
                                        allArrClientTop[ind][tabName][i] = el
                                    })
                                    const tmp = arrCopy[0]['id'] ? arrCopy[0]['id'] : ''
                                    const jsonTmp: any = {}
                                    jsonTmp['id'] = tmp

                                    switch (tabName) {
                                        case 'face-1':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'face-2':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'face-3':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'face-4':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'face-5':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'face-6':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'face-all':
                                            allArrClientTop[ind]['face-1'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['face-2'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['face-3'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['face-4'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['face-5'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['face-6'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'tooth-right':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'tooth-front':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'tooth-left':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'tooth-upper':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'tooth-overjet':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'tooth-lower':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'tooth-all':
                                            allArrClientTop[ind]['tooth-right'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['tooth-front'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['tooth-left'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['tooth-upper'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['tooth-overjet'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['tooth-lower'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'aligner-right':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'aligner-front':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'aligner-left':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'aligner-upper':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'aligner-overjet':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'aligner-lower':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'aligner-all':
                                            allArrClientTop[ind]['aligner-right'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['aligner-front'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['aligner-left'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['aligner-upper'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['aligner-overjet'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['aligner-lower'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'movie-1':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'movie-2':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'movie-3':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'movie-4':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'movie-5':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'movie-6':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'movie-all':
                                            allArrClientTop[ind]['movie-1'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['movie-2'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['movie-3'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['movie-4'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['movie-5'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['movie-6'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'other-1':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'other-2':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'other-3':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'other-4':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'other-5':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'other-6':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'other-all':
                                            allArrClientTop[ind]['other-1'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['other-2'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['other-3'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['other-4'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['other-5'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['other-6'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'xp-1':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'xp-2':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'xp-3':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'xp-4':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'xp-5':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'xp-6':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'xp-all':
                                            allArrClientTop[ind]['xp-1'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['xp-2'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['xp-3'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['xp-4'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['xp-5'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['xp-6'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        default:
                                            break
                                    }
                                }
                            }
                            this.count++
                            const emitArrAll: any = {}
                            emitArrAll['registration'] = allArrClientTop
                            emitArrAll['checkChange'] = true
                            this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                            // });
                        }
                        this.arrStyle = []
                    } else {
                        if (arrCopy != undefined && arrCopy.length > 0) {
                            arrCopy.forEach(el => {
                                if (el['id'] != '') {
                                    const style: any = {
                                        'border': '1px solid #faa',
                                    }
                                    this.arrStyle.push(style)
                                } else {
                                    this.arrStyle.push({})
                                }
                            })
                        }
                    }
                    const emitStyle: any = {}
                    emitStyle['style'] = this.arrStyle
                    emitStyle['tabName'] = tabName
                    emitStyle['arrCopy'] = arrCopy
                    this.clientTopServices.emitChangeStyle(emitStyle)
                } else {
                    if (tabName.includes('movie')) {
                        if (arrCopy != undefined && arrCopy.length > 0) {
                            arrCopy.forEach(el => {
                                if (el['id'] != '') {
                                    const style: any = {
                                        'border': '1px solid #faa',
                                    }
                                    this.arrStyle.push(style)
                                } else {
                                    this.arrStyle.push({})
                                }
                            })
                        }
                    } else {
                        if (arrCopy != undefined && arrCopy.length > 0) {
                            const ind = this.clientTopServices.getIndex()
                            // this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(allArr => {
                            const allArrClientTop: any[] = this.clientTopServices.getAllArrClientTop()
                            if (this.count == 0) {
                                if (allArrClientTop != undefined && allArrClientTop.length > 0) {
                                    arrCopy.forEach((el, i) => {
                                        allArrClientTop[ind][tabName][i] = el
                                    })
                                    const tmp = arrCopy[0]['id'] ? arrCopy[0]['id'] : ''
                                    // const jsonTmp: any = {};
                                    // jsonTmp['id'] = tmp;
                                    const jsonTmp: any = jQuery.extend(true, {}, arrCopy[0])

                                    switch (tabName) {
                                        case 'face-1':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'face-2':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'face-3':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'face-4':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'face-5':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'face-6':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['face-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'face-all':
                                            allArrClientTop[ind]['face-1'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['face-2'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['face-3'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['face-4'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['face-5'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['face-6'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'tooth-right':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'tooth-front':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'tooth-left':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'tooth-upper':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'tooth-overjet':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'tooth-lower':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['tooth-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'tooth-all':
                                            allArrClientTop[ind]['tooth-right'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['tooth-front'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['tooth-left'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['tooth-upper'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['tooth-overjet'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['tooth-lower'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'aligner-right':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'aligner-front':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'aligner-left':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'aligner-upper':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'aligner-overjet':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'aligner-lower':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['aligner-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'aligner-all':
                                            allArrClientTop[ind]['aligner-right'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['aligner-front'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['aligner-left'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['aligner-upper'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['aligner-overjet'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['aligner-lower'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'movie-1':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'movie-2':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'movie-3':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'movie-4':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'movie-5':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'movie-6':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['movie-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'movie-all':
                                            allArrClientTop[ind]['movie-1'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['movie-2'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['movie-3'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['movie-4'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['movie-5'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['movie-6'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'other-1':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'other-2':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'other-3':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'other-4':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'other-5':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'other-6':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['other-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'other-all':
                                            allArrClientTop[ind]['other-1'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['other-2'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['other-3'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['other-4'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['other-5'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['other-6'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        case 'xp-1':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][0] = jsonTmp
                                            }
                                            break
                                        case 'xp-2':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][1] = jsonTmp
                                            }
                                            break
                                        case 'xp-3':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][2] = jsonTmp
                                            }
                                            break
                                        case 'xp-4':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][3] = jsonTmp
                                            }
                                            break
                                        case 'xp-5':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][4] = jsonTmp
                                            }
                                            break
                                        case 'xp-6':
                                            if (tmp != '') {
                                                allArrClientTop[ind]['xp-all'][5] = jsonTmp
                                            }
                                            break
                                        case 'xp-all':
                                            allArrClientTop[ind]['xp-1'][0] = jQuery.extend(true, {}, arrCopy[0])
                                            allArrClientTop[ind]['xp-2'][0] = jQuery.extend(true, {}, arrCopy[1])
                                            allArrClientTop[ind]['xp-3'][0] = jQuery.extend(true, {}, arrCopy[2])
                                            allArrClientTop[ind]['xp-4'][0] = jQuery.extend(true, {}, arrCopy[3])
                                            allArrClientTop[ind]['xp-5'][0] = jQuery.extend(true, {}, arrCopy[4])
                                            allArrClientTop[ind]['xp-6'][0] = jQuery.extend(true, {}, arrCopy[5])
                                            break
                                        default:
                                            break
                                    }
                                }
                            }
                            this.count++
                            const emitArrAll: any = {}
                            emitArrAll['registration'] = allArrClientTop
                            emitArrAll['checkChange'] = true
                            this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                            // });
                        }
                    }
                    const emitStyle: any = {}
                    emitStyle['style'] = this.arrStyle
                    emitStyle['tabName'] = tabName
                    emitStyle['arrCopy'] = arrCopy
                    this.clientTopServices.emitChangeStyle(emitStyle)
                }
            } else {
                if (tabName == emitArrCopy.tabName) {
                    const allArrClientTop: any[] = this.clientTopServices.getAllArrClientTop()
                    const ind = this.clientTopServices.getIndex()
                    this.pastedIndex = ind
                    allArrClientTop[ind][tabName] = emitArrCopy.arrCopy
                    window['canvasVideo'] = allArrClientTop[ind][tabName]['canvasVideo']
                    const emitArrAll: any = {}
                    emitArrAll['registration'] = allArrClientTop
                    emitArrAll['checkChange'] = true
                    this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                    this.showPaste = false
                    this.cutDsd = false
                }
            }
        }
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/registration/modal-client-detail-registration.component.ts